export default "__VITE_ASSET__89cb13fd__"